import React from "react";
import Container from "react-bootstrap/Container";
import Section from "components/Section";
import SectionHeader from "components/SectionHeader";
import ToursTable from "components/ToursTable";

export default function ToursSection(props) {
  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container fluid style={{maxWidth: '1400px'}}>
        <SectionHeader
          title="Tours"
          subtitle=""
          size={3}
          spaced={true}
          className="text-center"
        />
        <ToursTable />
      </Container>
    </Section>
  );
};
